import styled from 'styled-components';

const ClearButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
`;

export default ClearButton;
